// extracted by mini-css-extract-plugin
export default {"email-verification-container":"EmailVerification_email-verification-container__VPZfv","icon":"EmailVerification_icon__knFyT","message":"EmailVerification_message__AUgta"};